(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_product_access_point"] && !Shopify.designMode) return;
  try {
    
/* Swiper JS */
var script = document.createElement("script");
script.src = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
script.onload = function() {
  new Swiper(".custom_mySwiper", {
    slidesPerView: 4,
    spaceBetween: 0,
    watchOverflow: false, // always show arrows
    navigation: {
      nextEl: ".custom_swiper-button-next",
      prevEl: ".custom_swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      0: { slidesPerView: 1 }
    }
  });

  // Read more logic
  document.querySelectorAll(".custom_read-more").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var parent = btn.closest(".custom_product-description");
      var fullText = parent.getAttribute("data-full");
      parent.innerHTML = fullText;
    });
  });
};
document.head.appendChild(script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  // Select the element
const btn = document.querySelector('.button.button--primary.button--md.icon-with-text:last-child');

if (btn) {
  // Check if it has an href attribute
  if (btn.hasAttribute('href') && btn.getAttribute('href').trim() !== "") {
    btn.style.display = 'inline-flex'; // Show if href exists
  } else {
    btn.style.display = 'none';   // Hide if no href
  }
}

  } catch(e) { console.error(e); }
})();
})();
